<template>
  <div class="groupfollower-box">
    <div class="groupfollower-title1">Followers</div>
    <div class="groupfollower-title2">Send notification to followers:</div>
    <el-input
      type="textarea"
      class="activity-cont"
      v-model="userParams.content"
    ></el-input>
    <div class="footer">
      <el-button @click.stop="sendGroupMessage">Send</el-button>
    </div>
    <div class="groupfollower-title2" v-if="memberList.length > 0">
      People who care about you recently
    </div>
    <div class="groupfollower-title2" v-else>No follower.</div>
    <div class="member-list-box">
      <div
        class="member-content"
        v-for="(item, index) in memberList"
        :key="index"
      >
        <img :src="item.covey_user ? item.covey_user.photo : ''" />
        <el-tooltip
          effect="light"
          :content="item.covey_user ? item.covey_user.realname : ''"
          placement="bottom-start"
        >
          <div class="member-name">
            {{ item.covey_user ? item.covey_user.realname : "" }}
          </div>
        </el-tooltip>
      </div>
    </div>
    <div v-if="isMoreMembers" class="view-more">
      <el-button @click.stop="loadMoreGroupMemberList"
        >VIEW MORE FOLLOWERS</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      memberList: [],
      isMoreMembers: false,
      userParams: { content: "" },
      pageMemberParams: {
        limit: 12,
        page: 1,
      },
    };
  },
  mounted() {
    this.getGroupMemberList();
  },
  methods: {
    async getGroupMemberList() {
      //是否更多
      let params = { ...this.pageMemberParams };
      const { status, data } = await this.$api.courseApi.getGroupMemberList(
        params
      );
      if (status === "0") {
        this.isMoreMembers =
          this.pageMemberParams.page <
          Math.ceil(data.count / this.pageMemberParams.limit);
        this.memberList = data.rows;
      }
    },
    async loadMoreGroupMemberList() {
      if (this.isMoreMembers) {
        //是否更多
        let params = { ...this.pageMemberParams };
        const { status, data } = await this.$api.courseApi.getGroupMemberList(
          params
        );
        if (status === "0") {
          this.isMoreMembers =
            this.pageMemberParams.page <
            Math.ceil(data.count / this.pageMemberParams.limit);
          this.memberList = this.memberList.concat(data.rows);
        }
      }
    },
    async sendGroupMessage() {
      let params = { ...this.userParams };
      if (!params.content) {
        this.$message({
          type: "warning",
          message: "Please fill in the content of the notification",
        });
        return;
      }
      const { status, message } = await this.$api.courseApi.sendGroupMessage(
        params
      );
      if (status === "0") {
        this.$message({
          type: "success",
          message: "Successfully post",
        });
        this.userParams = { activityContent: "" };
      } else {
        this.$message({
          type: "error",
          message: "Failed to send notification",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.groupfollower-box {
  padding: 24px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  /deep/ .el-textarea__inner {
    height: vh(245);
    padding: 14px 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #181d2c;
    line-height: 20px;
  }
  .footer {
    text-align: right;
    padding: 24px 0;
    box-sizing: border-box;
    .el-button {
      width: vw(100);
      height: vw(40);
      background: #f48c06;
      border-radius: 4px;
      color: #ffffff;
      font-weight: 500;
      font-size: 14px;
      border: none;
      outline: none;
      &:hover {
        opacity: 0.54;
      }
    }
  }
  .groupfollower-title1 {
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #181d2c;
    line-height: 25px;
    margin-bottom: 20px;
  }
  .groupfollower-title2 {
    height:25px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #181d2c;
    line-height: 25px;
    margin-bottom: 20px;
  }
  .member-list-box {
    // width: vw(1013);
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    .member-content {
      width: vw(169);
      width: vw(110);
      padding-right: vw(38);
      box-sizing: border-box;
      img {
        width: vw(72);
        height: vw(72);
        border-radius: 50%;
      }
      .member-name {
        height: vh(56);
        line-height: vh(56);
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #201002;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .view-more {
    margin: vw(40) 0;
    text-align: center;
    .el-button {
      width: vw(280);
      height: vw(40);
      background: #f48c06;
      border-radius: 32px;
      color: #ffffff;
      font-weight: 600;
      font-size: vw(16);
      border: none;
    }
  }
}
</style>